import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Resource from "ui/layouts/Resource";
import { withPaymentMethods } from "./PaymentMethodsProvider";
import VisiblePaymentMethods from "./VisiblePaymentMethods";
import FeesAndCommisions from "./FeesAndCommisions";

const PaymentMethods = () => (
    <Resource
        breadcrumbsProps={{
            sx: {
                mb: 0
            },
            heading: 'Payment Methods',
            links: [
                {
                    name: ''
                }
            ]
        }}
    >
        <Box
            sx={{
                display: 'grid',
                gap: 5
            }}
        >
            <Card
                sx={{
                    maxWidth: 'fit-content'
                }}
            >
                <CardHeader
                    title='Activate payment methods'
                    subheader="Switch payment methods to 'enabled' to activate them."
                    sx={{
                        pb: 3
                    }}
                />
            </Card>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                    gridTemplateColumns: '1fr 1fr',
                    alignItems: 'flex-start'
                }}
            >
                <VisiblePaymentMethods />
                <FeesAndCommisions />
            </Box>
        </Box>
    </Resource>
);

export default withPaymentMethods(PaymentMethods);
